export const CUSTOM_MODAL_WIDTH=  {
    large: '1000px',
    medium: '800px',
}
